import { Component, Input } from '@angular/core';
import { User } from '../../interface/user';
import { AuthService } from '../../services/auth.service';
import { AnalyticsService } from '../../@core/utils';

@Component({
  selector: 'ngx-admin-charts',
  templateUrl: './admin-charts.component.html',
  styleUrls: ['./admin-charts.component.scss'],
})
export class AdminChartsComponent {
  @Input() isExpand: boolean;
  @Input() currentUser: User;
  @Input() currentTheme: string;

  period: string = 'week';
  type: string = 'week';
  types: string[] = ['week', 'month', 'year'];
  currentView = 'subject';
  viewBy = ['subject', 'grade'];

  constructor(private authService: AuthService,
    public alayticsService: AnalyticsService) { }


  closeExpandView() {
    this.authService.closeDialog.emit(true);
  }

  setPeriodAndGetChartData(event: string): void {
    const value = event;
    if (this.period !== value) {
      this.period = value;
    }
  }
}
